<!-- Error -->
<div *ngIf="error" class="alert alert-danger alert-hover-pointer" (click)="getAllSurveys(); survey = null; error = null">
    <i class="fas fa-chevron-left mr-2"></i>{{ error }} Click here to return to the welcome page.
</div>

<div *ngIf="survey && !iePrompt && !bypassWelcome">
    <img *ngIf="survey.surveyLogoPath" src="{{ survey.surveyLogoPath }}" alt="Logo" class="logo">
    <h2>Welcome to the {{ survey.surveyName }}</h2>
    <div [innerHtml]="survey.surveyIntro"></div>
    <button *ngIf="!error" type="button" class="btn btn-success" (click)="newCase(nextCaseCode, survey.groupLevelId)" [disabled]="!nextCaseCode">
        {{ nextCaseCode ? survey.surveyIntroButton : 'Loading...' }}
    </button>
</div>

<div *ngIf="!survey && !iePrompt && !bypassWelcome">
    <div class="row mb-4">
        <!-- <div class="col-1">
            <img src="/assets/images/nhsbn-mark.png" alt="Logo" class="logo">
        </div> -->
        <div class="col-12 text-center">
            <h2>Welcome to the NHS Benchmarking Network's survey site</h2>
            <h4 class="mb-5">The following surveys are currently available for those who have been invited to take part.</h4>
            <div *ngIf="!isLive" class="test-banner">This website is currently in test mode. No data will be submitted.</div>
        </div>
    </div>
    <div *ngIf="allSurveys" class="row">
        <div *ngFor="let survey of allSurveys; let i = index" class="col-md-6 mb-4">
            <div class="card h-100">
                <div class="card-body">
                    <img [src]="survey.surveyLogoPath" class="logo" alt="Survey logo">
                    <h5 class="card-title">{{ survey.surveyName }}</h5>
                    <p class="card-subtitle mb-2 text-muted" [innerHTML]="survey.surveyIntroShort"></p>
                    <hr>
                    <p *ngIf="!survey.open" class="text-danger font-weight-bold">
                        This survey is not currently open.
                    </p>
                    <div *ngIf="survey.open">
                        <p>
                            To take part in this survey, please complete the two-part code you received as part of your invitation to participate. Then click 'Start Survey'.
                        </p>
                        <div class="form-inline">
                            <input type="number" [(ngModel)]="submissionCode[i]" [class]="survey.surveyCode + '-1 form-control mb-2 w-50 mr-2'" placeholder="12345" />
                            <input type="number" [(ngModel)]="organisationCode[i]" [class]="survey.surveyCode + '-2 form-control mr-2 mb-2 w-25'" placeholder="123" />
                            <button [disabled]="!submissionCode[i] || !organisationCode[i]" class="btn btn-success mb-2" (click)="startSurvey(survey.surveyCode)">Start Survey</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="iePrompt" class="text-center">
    <h2>Your browser version is not supported</h2>
    <p>Please use the latest version of Chrome, Firefox or Safari to access this website.</p>
</div>